import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editorial-clients',
  templateUrl: './editorial-clients.component.html',
  styleUrls: ['./editorial-clients.component.css']
})
export class EditorialClientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
